
import {defineComponent, PropType} from 'vue';
import {TopMenuItem, User, Breadcrumb} from './types';
import Text from '@ohrm/oxd/core/components/Text/Text.vue';
import Icon from '@ohrm/oxd/core/components/Icon/Icon.vue';
import Navigation from '@ohrm/oxd/core/components/Topbar/Navigation.vue';
import UserDropdown from '@ohrm/oxd/core/components/Topbar/UserDropdown.vue';

export default defineComponent({
  name: 'oxd-top-bar',

  emits: ['collapse'],

  props: {
    toggle: {
      type: Boolean,
      default: false,
    },
    menuItems: {
      type: Object as PropType<TopMenuItem[]>,
    },
    user: {
      type: Object as PropType<User>,
    },
    breadcrumb: {
      type: Object as PropType<Breadcrumb>,
    },
  },

  components: {
    'oxd-text': Text,
    'oxd-icon': Icon,
    'oxd-navigation': Navigation,
    'oxd-user-dropdown': UserDropdown,
  },

  computed: {
    headerClasses(): object {
      return {
        'oxd-topbar-header': true,
        toggled: this.toggle,
      };
    },
    bodyClasses(): object {
      return {
        'oxd-topbar-body': true,
        toggled: this.toggle,
      };
    },
  },
});
